<template>
	<div class="export-wrap">
		<el-upload class="upload-demo" action="#" accept="xls,xlsx"
			:data="additionalData" :before-upload="handleBeforeUpload" :http-request="httpRequest">
			<el-button type="primary"> <i class="iconfont icon-piliangchuangjian"></i>批量创建</el-button>
		</el-upload>

		<el-dialog title="批量导入" width="30%" v-model="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
			<div class="export-main" v-if="scssce">
				<div class="export-img">
					<img src="@/assets/images/downloadC.png" />
					<span class="green">上传成功</span>
					<div class="linegreen"></div>
				</div>
				<div class="export-text">{{ msg }}</div>
			</div>
			<div class="export-main" v-else>
				<div class="export-img">
					<img src="@/assets/images/downloadF.png" />
					<span class="red">上传失败</span>
					<div class="linered"></div>
				</div>
				<div class="export-text">
					<span class="msg-text" v-for="(item, index) in msgList" :key="index"> {{ index + 1 }}、{{ item }} </span>
				</div>
				<div class="export-tips">请修正后重新导入</div>
			</div>
		</el-dialog>
	</div>
</template>

<script setup>
import { reactive, ref, toRefs } from 'vue'
import { checkFileUpload } from '@/utils/scm'
import { listToString } from '@/utils/dynamic'
import { UploadFiles } from '@/api/upload'
import defaultSettings from '@/settings'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	// 父组件 v-model 没有指定参数名，则默认是 modelValue
	modelValue: [String, Object, Array],
	// 图片数量限制
	limit: {
		type: Number,
		default: 1
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['xls', 'xlsx']
	fileType: {
		type: Array,
		default: () => ['xls', 'xlsx']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})
const modeList = ref([]) //正确的列表
const sencond = ref(2) //设置初始倒计时

const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const data = reactive({
	dialogVisible: false,
	msg: '',
	scssce: true,
	msgList: []
})

const { dialogVisible, msg, scssce, msgList } = toRefs(data)

// 上传之前
const handleBeforeUpload = (file) => {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

// 文件上传处理
const httpRequest = (options) => {
	let fileFormData = new FormData()

	fileFormData.append('files', options.file, options.file.name)

	UploadFiles(fileFormData).then((res) => {
		if (res && res.ResData) {
			if (res.ErrCode == '0') {
				dialogVisible.value = true
				scssce.value = true

				var dataList = res.ResData
				for (let i in dataList) {
					var name = dataList[i].FileName
					var icon = dataList[i].FilePath
					modeList.value.push({ name: name, url: icon })
				}
				msg.value = res.ErrMsg
				emit('update:modelValue', listToString(modeList.value))
			} else {
				dialogVisible.value = true
				scssce.value = false
				if (res.ErrMsg.indexOf('|')) {
					msgList.value = res.ErrMsg.split('|')
				} else {
					msgList.value.push(res.ErrMsg)
				}
			}
			getSencond()
		}
	})
}
// 自动关闭窗口
const getSencond = () => {
	const interval = window.setInterval(function () {
		--sencond.value
		if (sencond.value === 0) {
			dialogVisible.value = false
			window.clearInterval(interval)
			//倒计时结束时运行的业务逻辑，这里的是关闭当前页面
			//sendMsg()
		}
	}, 1000)
}
</script>

<style lang="scss" scoped>
.export-wrap {
	display: inline-block;
	text-align: left;
	.upload-demo {
		display: inline-block;
		margin: 0 10px;
		.el-button {
			padding: 10px 17px;
		}
		.el-upload-list {
			display: none;
		}
	}
	.export-main {
		text-align: center;
		.export-img {
			height: 100px;
			display: block;
			line-height: 23px;
			img {
				width: 100px;
				height: 100px;
			}
			.green {
				display: block;
				color: #4a5669;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
			}
			.red {
				display: block;
				color: #4a5669;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
			}
			.linegreen {
				width: 80%;
				height: 6px;
				background: #56be94;
				border-radius: 5px;
				margin: 10px auto;
			}
			.linered {
				width: 80%;
				height: 6px;
				background: #e1e4e8;
				border-radius: 5px;
				margin: 10px auto;
			}
		}
		.export-text {
			display: block;
			width: 100%;
			box-sizing: border-box;
			min-height: 40px;
			margin-top: 38px;
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 23px;
			color: #898ea0;
			.msg-text {
				width: 80%;
				margin: 0 auto;
				display: block;
				line-height: 36px;
				text-align: left;
			}
		}
		.export-tips {
			display: block;
			width: 80%;
			margin: 10px auto;
			margin-top: 10px;
			font-size: 12px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 30px;
			color: #f57171;
			text-align: left;
		}
	}
}
</style>
